// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"90":"96f3f65d","233":"e482ee2e","447":"1cad5f30","614":"ff3c25a3","931":"11dfe30a"}[chunkId] + ".chunk.js";
};